import { BaseSurvey } from '../base-survey';
import { FactorySurveyView } from './factory-view';
import { validateAdinsightRecommendationTriggerCondition } from '../utils';

export class AdInsightRecommendationSurvey extends BaseSurvey {
  getSurveyName = () => 'AdInsightRecommendationSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    '78f8a552-767c-4247-915b-899bdd00bd06' : 'cc5db067-561d-4f60-a048-12767782666c';

  getInitializationConfig = () => ({
    initGroup: 100,
    initStartDate: '2023-03-02',
    initEndDate: '2023-06-09',
  });

  validateTriggerCondition = () => validateAdinsightRecommendationTriggerCondition(this, 'campaign/vnext/recommendations', 'IsRecommendationPageCsatPilotEnabled');

  getSurveyComponent = () => FactorySurveyView;
}
